<template>
  <div class="wrap-lg">
    <div class="boxs-top clearfix">
      <div class="top-title"><span>推荐检测服务</span></div>
       <div class="top-more">
         <my-link href="/reservice">
           查看更多
           <i class="el-icon-arrow-right"></i>
         </my-link>
       </div>
    </div>
    <div class="top-divider"></div>
    <div class="home-list-box">
      <div class="box-left">
        <my-link :href="'/reservice/detail?sid='+firstTestServices.id" target="_blank">
          <div class="box-title">{{firstTestServices.title}}</div>
          <div class="box-divider"></div>
          <div class="box-desc">{{firstTestServices.description}}</div>
          <img :src="firstTestServices.imgUrl" alt="" />
        </my-link>
      </div>
      <div class="box-right">
        <div v-for="testService in testServices" :key="testService.id"  class="box-item">
          <my-link :href="'/reservice/detail?sid='+testService.id" target="_blank">
            <i v-if="testService.isHot === '1'" class="hot-icon"></i>
            <img :src="testService.imgUrl" alt="REACH检测简介" />
            <div class="box-title">{{testService.title}}</div>
            <div class="box-desc">{{testService.description}}</div>
          </my-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFirst } from '@/api/recommend/testing'

export default {
  name: 'recommendService',
  data () {
    return {
      firstTestServices: {},
      testServices: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      let param = {}
      getFirst(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData && result.bizData.length > 0) {
            this.firstTestServices = result.bizData[0]
            this.testServices = result.bizData.slice(1)
          }
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
